<script>
export default {
  name: "UiTextarea",
  props: {
    value: {
      type: String,
      default: ''
    }
  },
};
</script>

<template>
  <textarea
    class="UiTextarea"
    rows="3"
    :value="value"
    @input="$emit('input', $event.target.value)"
  ></textarea>
</template>

<style lang="scss" scoped>
.UiTextarea {
  border: var(--input-border);
  min-height: var(--input-height);
  padding: 10px var(--input-padding-x);
  border-radius: var(--input-radius);
  width: 100%;
  min-width: 0px;

  &:focus {
    border-color: var(--input-focus-border-color);
    box-shadow: var(--input-focus-shadow);
  }
}
</style>
